import SettingDTO from 'dto/tenants/settingDTO';
import { mapFromUserSettings, mapToUserSetting } from 'mappings/userSettingMapping';
import { UserSettings } from 'models/users/userSetting';
import AppError from 'utils/appError';
import http from './httpService';

//the signed-in user's own settings with their effective values (GET settings/user); the API creates no rows
export async function apiGetUserSettings(accessToken: string): Promise<UserSettings> {
  try {
    const ar = await http.get<SettingDTO[]>('/settings/user', http.getRequestConfig(accessToken));

    return mapFromUserSettings(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

//writes one setting of the signed-in user (PUT settings/user); the first write creates the row
export async function apiSetUserSetting(name: string, value: boolean, accessToken: string): Promise<void> {
  try {
    await http.put('/settings/user', mapToUserSetting(name, value), http.getRequestConfig(accessToken));
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
